/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  InvalidateQueryFilters,
  QueryClient,
  useQuery,
  UseQueryResult,
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  GetUserSessionClientRequest,
  GetUserSessionClientSecurity,
} from "../models/operations/getusersessionclient.js";
import { useGramContext } from "./_context.js";
import {
  QueryHookOptions,
  SuspenseQueryHookOptions,
  TupleToPrefixes,
} from "./_types.js";
import {
  buildUserSessionClientQuery,
  prefetchUserSessionClient,
  queryKeyUserSessionClient,
  UserSessionClientQueryData,
} from "./userSessionClient.core.js";
export {
  buildUserSessionClientQuery,
  prefetchUserSessionClient,
  queryKeyUserSessionClient,
  type UserSessionClientQueryData,
};

export type UserSessionClientQueryError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * getUserSessionClient userSessionClients
 *
 * @remarks
 * Get a user_session_client by id.
 */
export function useUserSessionClient(
  request: GetUserSessionClientRequest,
  security?: GetUserSessionClientSecurity | undefined,
  options?: QueryHookOptions<
    UserSessionClientQueryData,
    UserSessionClientQueryError
  >,
): UseQueryResult<UserSessionClientQueryData, UserSessionClientQueryError> {
  const client = useGramContext();
  return useQuery({
    ...buildUserSessionClientQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

/**
 * getUserSessionClient userSessionClients
 *
 * @remarks
 * Get a user_session_client by id.
 */
export function useUserSessionClientSuspense(
  request: GetUserSessionClientRequest,
  security?: GetUserSessionClientSecurity | undefined,
  options?: SuspenseQueryHookOptions<
    UserSessionClientQueryData,
    UserSessionClientQueryError
  >,
): UseSuspenseQueryResult<
  UserSessionClientQueryData,
  UserSessionClientQueryError
> {
  const client = useGramContext();
  return useSuspenseQuery({
    ...buildUserSessionClientQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

export function setUserSessionClientData(
  client: QueryClient,
  queryKeyBase: [
    parameters: {
      id: string;
      gramSession?: string | undefined;
      gramKey?: string | undefined;
      gramProject?: string | undefined;
    },
  ],
  data: UserSessionClientQueryData,
): UserSessionClientQueryData | undefined {
  const key = queryKeyUserSessionClient(...queryKeyBase);

  return client.setQueryData<UserSessionClientQueryData>(key, data);
}

export function invalidateUserSessionClient(
  client: QueryClient,
  queryKeyBase: TupleToPrefixes<
    [parameters: {
      id: string;
      gramSession?: string | undefined;
      gramKey?: string | undefined;
      gramProject?: string | undefined;
    }]
  >,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "userSessionClients", "get", ...queryKeyBase],
  });
}

export function invalidateAllUserSessionClient(
  client: QueryClient,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "userSessionClients", "get"],
  });
}
